import { render, staticRenderFns } from "./Grouparchives.vue?vue&type=template&id=6241fa90&style=height%3A%20100%25%3B"
import script from "./Grouparchives.vue?vue&type=script&lang=js"
export * from "./Grouparchives.vue?vue&type=script&lang=js"
import style0 from "./Grouparchives.vue?vue&type=style&index=0&id=6241fa90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports